export const MAX_TRAILER_NUMBER_HOOK_LENGTH = 20;

// Validation messages (aligned with Driver App i18n: dropHook.invalidTrailer, trailerAlreadyHooked, duplicateTrailerEntry)
export const TRAILER_HOOK_VALIDATION = {
  REQUIRED: "* Required",
  ALREADY_HOOKED: "Trailer already hooked",
  DUPLICATE: "Duplicate trailer entry",
  INVALID_STATUS: (allowed) =>
    `Valid trailer status: ${allowed.length === 0 ? "None" : allowed.join(", ")}`,
  STRAIGHT_TRUCK: "Straight truck cannot be hooked",
  MAX_LENGTH: `Trailer number must be ${MAX_TRAILER_NUMBER_HOOK_LENGTH} characters or fewer`,
  INVALID_FORMAT: "Invalid trailer number",
};

// Dolly validation messages for enableDollyHook feature
export const DOLLY_HOOK_VALIDATION = {
  REQUIRED: "Dolly number is required",
  DUPLICATE: "Duplicate dolly entry",
  INVALID_STATUS: (allowed) =>
    `Valid dolly status: ${allowed.length === 0 ? "None" : allowed.join(", ")}`,
};

// Get trailer details label (e.g., "TRAILER 2 DETAILS")
export const getTrailerDetailsLabel = (trailerNumber) =>
  `TRAILER ${trailerNumber} DETAILS`;
